export const ALLOWED_FLAG_MESSAGES = {
	DUPLICATE_TITLE: 'A page with this title already exists',
	DUPLICATE_TITLE_WITHIN_EDITOR: 'Give this page a unique title to move',
	DUPLICATE_EDIT_PAGE_BLOG_TITLE: 'Cannot convert draft, a blog with this title already exists',
	DUPLICATE_VIEW_PAGE_BLOG_TITLE: 'Cannot convert page, a blog with this title already exists',
	EMPTY_TITLE: 'empty-title',
	TITLE_REQUIRED: 'title-required',
	AI_GENERATED_TITLE: 'Review your AI-generated title',
	AI_GENERATED_TITLE_ERROR: 'We couldn’t generate a title for you',
	INVALID_PAGE_TITLE: 'You need to include the title to update a page.',
	// this error message is returned with status 400 in fabric editor when page with duplicate title is published
	DUPLICATE_TITLE_WITH_BAD_EXCEPTION:
		'com.atlassian.confluence.api.service.exceptions.BadRequestException: A page with this title already exists',
	OTHER_PUBLISH: 'other-publish',
	OTHER_RESTORE: 'other-restore',
	CONTENT_RECONCILIATION: 'content-reconciliation',
	TITLE_TOO_LONG: 'Title cannot be longer than 255 characters.',
	MEDIA_FAILED: "Can't publish changes",
	SYNCHRONY_WAS_NOT_CONNECTED_ERROR:
		'An unexpected error occurred after connecting to editing services.',
	SYNCHRONY_WAS_NOT_INITIALIZED_ERROR:
		'An unexpected error occurred when connecting to editing services.',
	SYNCHRONY_ACK_MISSING_ERROR:
		'An unexpected error occurred after requesting the final editor state.',
	FOUND_INVALID_TEMPLATE_VARIABLE:
		'Found multiple variables with the same name but different types',
	DUPLICATE_TITLE_TEMPLATE: 'Template title already used, please use a different name.',
	TEMPLATE_CONTENT_PARSING_FAILURE: 'template-content-parsing-failure',
	SYNCHRONY_UNEXPECTED_ERROR:
		'An unexpected error occurred while requesting the final editor state.',
	PUBLISH_TIME_TOO_LONG_ERROR: 'An error occurred and it took too long to publish the page.',
	SCHEDULE_PUBLISH_ERROR: 'An error occurred when scheduling the publish.',
	CANCEL_SCHEDULE_PUBLISH_ERROR: 'An error occured when cancelling the scheduled publish.',
	SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR:
		'Add a title, and you can set a date and time for publishing.',
	REVERT_CONTENT_ERROR: 'An error occurred while trying to revert the page.',
	PARENT_NOT_PUBLISHED:
		'com.atlassian.confluence.api.service.exceptions.BadRequestException: Could not publish draft. Parent page has not been published.',
	RESTORE_CONTENT_SUCCESS: 'Page/blogpost has been reverted to last version',
	BLOGIFY_BLOGPOST_SUCCESS: 'Page converted to a blog post',
	TEMPLATE_PUBLISH_TAKING_LONG: 'Bear with us, this is taking a moment.',
	COLLAB_INIT_TIMEOUT_TAKING_TOO_LONG: 'Collab init event is taking too long',
	ERROR_MESSAGE_WITH_BAD_EXCEPTION:
		'com.atlassian.confluence.api.service.exceptions.BadRequestException:',
	CONFLICT_DRAFT_VERSIONING: 'Draft versioning is not supported.',
	COLLAB_STATUS_ERROR: "Can't save changes.",
	TEMPLATE_INVALID_SPACEKEY_ERROR: 'Invalid spaceKeys.',
	TEMPLATE_BLANK_TITLE_ERROR: 'Template title cannot be null or empty string',
	CREATED_FROM_EXTENSION: 'Draft created from create page extension',
};
